/**
 *
 * AbsenceListItem
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import moment from 'moment';

// antd component
import { List } from 'antd';

// icons
import { CheckOutlined, CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';

import {
  getAbsenceReason,
  getAbsenceMainDate,
  getAbsenceStartDuration
} from 'utils/helpers/helper.generateData';
import { ABS_TYPES_LIST } from 'utils/helpers/helper.constant';

// context
import { useGetLocalUser } from 'engine/Contexts/User.context';

function AbsenceListItem({
  element,
  searchString,
  // formats
  timeFormat,
  dateFormat,
  // func
  customHighlighter,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('absence-list-meta', className);

  const localUser = useGetLocalUser()();

  const mainDate = getAbsenceMainDate(element);
  const reason = getAbsenceReason(element);
  const absenceDuration = getAbsenceStartDuration(element);
  
  const studentName = element?.student?.description
    ? `${element?.student?.description?.lastname} ${element?.student?.description?.firstname}`
    : '';
  
  const getAbsenceStatusIcon = type => {
    switch (type) {
      case 'pending':
        return <CustomIcons type="loop" />;
      case 'justification-missing':
        return <CustomIcons type="document" />;
      case 'sick':
        return <CustomIcons type="loop" />;
      case 'sickness-finish':
        return <CheckOutlined />;
      case 'accepted':
        return <CheckOutlined />;
      case 'refused':
        return <CloseOutlined />;
    }
  };
  
  return element && (
    <List.Item.Meta
      className={childClassNames}
      title={false}
      description={
        <>
          <div className="absence-description">

            <div className="abcence-wrapper-for-reason-processed">
              <span className={`status-tag status-tag--${element?.status}`}>
                {getAbsenceStatusIcon(element?.status)}
              </span>
            </div>

            <div className="absence-wrapper-date">
              <span className="absence-date">
                {moment(mainDate).format('dddd')}{' '}
                {moment(mainDate).format(dateFormat)}{' '}
              </span>

              {absenceDuration && (
                <span className="absence-time"> – {absenceDuration}</span>
              )}
            </div>

            <div className="absence-title">
              {element?.type === 'sickness' ? (
                <span className="title">
                  {ABS_TYPES_LIST?.find(e=>e?.key==element?.type)?.title}
                </span>
              ) : (
                <span className="title">
                  {ABS_TYPES_LIST?.find(e=>e?.key==element?.type)?.title}{!!reason ? ` : ${reason}` : ''}
                </span>
              )}
            </div>

            {localUser?.role == 'teacher' && studentName && (
              <div className='absence-student'>
                <CustomIcons type="academic" className="icon-student" />
                {studentName}
              </div>
            )}
            {localUser?.role == 'parent' && element?.status == 'justification-missing' && (
              <span className="need-acition-message">
                <ExclamationCircleOutlined /> Une action est requise de votre part
              </span>
            )}
          </div>
        </>
      }
    />
  );

};

AbsenceListItem.defaultProps = {
  dateFormat: 'DD.MM.YYYY',
  timeFormat: 'HH:mm',
};
AbsenceListItem.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  searchString: PropTypes.string,
  customHighlighter: PropTypes.func,
};

export default memo(AbsenceListItem);